import { render, staticRenderFns } from "./BaseIssueList.vue?vue&type=template&id=26c03e5a&scoped=true"
import script from "./BaseIssueList.vue?vue&type=script&lang=js"
export * from "./BaseIssueList.vue?vue&type=script&lang=js"
import style0 from "./BaseIssueList.vue?vue&type=style&index=0&id=26c03e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c03e5a",
  null
  
)

export default component.exports